import { Popover, PopoverTrigger, PopoverContent } from "@/modules/shared/ui/components/popover"
import {
  ApplicationCommentReaction,
  ApplicationCommentReactionEmoji,
} from "@/modules/recruitment/applications/dtos/ApplicationComment"

const QUICK_REACTIONS: { emoji: ApplicationCommentReactionEmoji; glyph: string }[] = [
  { emoji: "ThumbsUp", glyph: "👍" },
  { emoji: "Heart", glyph: "❤️" },
  { emoji: "Clap", glyph: "👏" },
]

const GLYPH_BY_EMOJI: Record<ApplicationCommentReactionEmoji, string> = {
  ThumbsUp: "👍",
  Heart: "❤️",
  Clap: "👏",
}

interface ReactionPickerProps {
  reactions: ApplicationCommentReaction[]
  onToggle: (emoji: ApplicationCommentReactionEmoji) => void
  disabled?: boolean
}

export function ReactionPicker({ reactions, onToggle, disabled }: ReactionPickerProps) {
  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {reactions.map((reaction) => (
        <button
          key={reaction.emoji}
          type="button"
          onClick={() => onToggle(reaction.emoji)}
          disabled={disabled}
          className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full border ${
            reaction.reactedByMe
              ? "bg-primary/10 border-primary/30 text-primary"
              : "border-border text-muted-foreground"
          }`}
        >
          <span>{GLYPH_BY_EMOJI[reaction.emoji]}</span>
          <span>{reaction.count}</span>
        </button>
      ))}

      <Popover>
        <PopoverTrigger asChild>
          <button
            type="button"
            disabled={disabled}
            className="text-xs px-2 py-0.5 rounded-full border border-border text-muted-foreground"
          >
            + react
          </button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-auto p-1 flex gap-1">
          {QUICK_REACTIONS.map((r) => (
            <button
              key={r.emoji}
              type="button"
              onClick={() => onToggle(r.emoji)}
              className="text-base p-1 rounded hover:bg-accent"
              aria-label={r.emoji}
            >
              {r.glyph}
            </button>
          ))}
        </PopoverContent>
      </Popover>
    </div>
  )
}
